// v-expand.js
export default {
  bind(el) {
    el.style.overflow = 'hidden'
    if (!el.dataset) el.dataset = {}
  },
  inserted(el, binding) {
    if (binding.value) {
      el.style.height = 'auto'
    } else {
      el.style.height = '0'
    }
  },
  update(el, binding) {
    const duration = 300 // 动画时间 (ms)
    const ease = 'ease'

    // 展开
    if (binding.value && !binding.oldValue) {
      el.style.height = el.scrollHeight + 'px'
      el.style.transition = `height ${duration}ms ${ease}, opacity ${duration}ms ${ease}`
      el.style.opacity = '1'

      // 动画结束后设为 auto，避免内容变化时卡死
      setTimeout(() => {
        if (binding.value) el.style.height = 'auto'
      }, duration)
    }

    // 收起
    else if (!binding.value && binding.oldValue) {
      // 先固定当前高度
      el.style.height = el.scrollHeight + 'px'
      el.style.transition = `height ${duration}ms ${ease}, opacity ${duration}ms ${ease}`
      el.style.opacity = '1'

      // 触发回流，再设为 0
      void el.offsetHeight
      el.style.height = '0'
      el.style.opacity = '0'
    }
  }
}
